import React from 'react'
import CommonHeader from '../navbars/CommonHeader';
import BrandLogo from '../navbars/BrandLogo';

/**
 * Header for the logged-out pages (register, forgot password, payment result):
 * the shared CommonHeader bar with the logo and no user menu.
 */
function NavbarTop() {
  return (
    <CommonHeader
      className="student-login-register"
      color="auto"
      tone="light"
      showUserMenu={false}
      left={(
        <a href="https://rizee.in" className="navbar-brand">
          <BrandLogo fill="#ffffff" />
        </a>
      )}
    />
  )
}

export default NavbarTop
